<template>
    <v-container fluid>
        <template v-if="this.customer">
            <customer-form
                :customer="customer"
                @saved="saved"
                type="edit"
                :titlePrefix="$t('customer.edit.texts.title-prefix')"
            ></customer-form>
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import CustomerModel from '@/models/Customer'
import CustomerForm from './Form'

export default {
    props: ['id'],

    data: () => {
        return {
            customer: null,
        }
    },

    components: {
        CustomerForm,
    },

    methods: {
        async getCustomer() {
            let customer = await this.model.find(this.id)

            this.customer = customer
        },

        saved() {
            this.$router.push({ name: 'customer' })
        },
    },

    computed: {
        model() {
            return new CustomerModel()
        },
    },

    created() {
        this.getCustomer()
    },
}
</script>
